import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

interface numberIconProps {
  breakPoint: number;
  currentStep: number;
  numberValue: number;
}

const NumberIcon: React.FC<numberIconProps> = ({
  breakPoint,
  currentStep,
  numberValue,
}) => {
  return (
    <React.Fragment>
      <Box
        sx={{
          width: { xs: "13px", sm: "13px", md: "22px" },
          height: { xs: "13px", sm: "13px", md: "22px" },
          borderRadius: { xs: "6.5px", sm: "6.5px", md: "11px" },
          textAlign: "center",
          backgroundColor: "#00000",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginRight: "5px",
        }}
        style={
          currentStep > breakPoint
            ? { backgroundColor: "#2685F8" }
            : {
                backgroundColor: "#ffffff",
                border: "0.8px solid #70707080",
              }
        }
      >
        <Typography
          sx={{
            letterSpacing: "0.26px",
            fontFamily: "Lato",
            fontSize: { xs: "9px", sm: "9px", md: "11px", xl: "18px" },
            lineHeight: { xs: "8px", sm: "8px", md: "8px", xl: "12px" },
            color: "#333333",
            fontWeight: "bold",
            opacity: 1,
            textAlign: "center",
          }}
          style={
            currentStep > breakPoint
              ? { color: "#FFFFFF" }
              : { color: "#70707080" }
          }
        >
          {numberValue}
        </Typography>
      </Box>
    </React.Fragment>
  );
};

export default NumberIcon;
